const LOCAL_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";
const AZURE_URL = "https://backendublickadmin.azurewebsites.net";

const Environment = () => {
    return LOCAL_URL;
}

export const TimeToReload = () => {
    return 6000;
}

export default Environment;